import React from 'react';

const ProjectTypesIcon = (props) => {

  let { 
    height, 
    width, 
    iconColor,
  } = props;
  
  const fillColor = iconColor || '#4A4A4A';

  return (
    <svg 
      width={width ? width : '21px'} 
      height={height ? height : '19px'}
      viewBox="0 0 26 24" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>Project Types and Templates</title>
        <defs>
            <path d="M24.25,23 L21.75,23 C21.06,23 20.5,22.44 20.5,21.75 L20.5,19.25 C20.5,18.56 21.06,18 21.75,18 L24.25,18 C24.94,18 25.5,18.56 25.5,19.25 L25.5,21.75 C25.5,22.44 24.94,23 24.25,23 Z M21.75,19 C21.61,19 21.5,19.11 21.5,19.25 L21.5,21.75 C21.5,21.89 21.61,22 21.75,22 L24.25,22 C24.39,22 24.5,21.89 24.5,21.75 L24.5,19.25 C24.5,19.11 24.39,19 24.25,19 L21.75,19 Z M14.25,23 L11.75,23 C11.06,23 10.5,22.44 10.5,21.75 L10.5,19.25 C10.5,18.56 11.06,18 11.75,18 L14.25,18 C14.94,18 15.5,18.56 15.5,19.25 L15.5,21.75 C15.5,22.44 14.94,23 14.25,23 Z M11.75,19 C11.61,19 11.5,19.11 11.5,19.25 L11.5,21.75 C11.5,21.89 11.61,22 11.75,22 L14.25,22 C14.39,22 14.5,21.89 14.5,21.75 L14.5,19.25 C14.5,19.11 14.39,19 14.25,19 L11.75,19 Z M4.25,23 L1.75,23 C1.06,23 0.5,22.44 0.5,21.75 L0.5,19.25 C0.5,18.56 1.06,18 1.75,18 L4.25,18 C4.94,18 5.5,18.56 5.5,19.25 L5.5,21.75 C5.5,22.44 4.94,23 4.25,23 Z M1.75,19 C1.61,19 1.5,19.11 1.5,19.25 L1.5,21.75 C1.5,21.89 1.61,22 1.75,22 L4.25,22 C4.39,22 4.5,21.89 4.5,21.75 L4.5,19.25 C4.5,19.11 4.39,19 4.25,19 L1.75,19 Z M23.5,18 L22.5,18 L22.5,13.5 C22.5,13.13 22.46,13.05 22.45,13.04 L22.45,13.04 C22.44,13.04 22.34,13 22,13 L13.5,13 L13.5,18 L12.5,18 L12.5,13 L3.75,13 C3.61,13 3.5,13.11 3.5,13.25 L3.5,18 L2.5,18 L2.5,13.25 C2.5,12.56 3.06,12 3.75,12 L12.5,12 L12.5,7 L10.75,7 C10.06,7 9.5,6.44 9.5,5.75 L9.5,1.25 C9.5,0.56 10.06,0 10.75,0 L15.25,0 C15.94,0 16.5,0.56 16.5,1.25 L16.5,5.75 C16.5,6.44 15.94,7 15.25,7 L13.5,7 L13.5,12 L22,12 C23.11,12 23.5,12.39 23.5,13.5 L23.5,18 Z M13.5,6 L15.25,6 C15.39,6 15.5,5.89 15.5,5.75 L15.5,1.25 C15.5,1.11 15.39,1 15.25,1 L10.75,1 C10.61,1 10.5,1.11 10.5,1.25 L10.5,5.75 C10.5,5.89 10.61,6 10.75,6 L13.5,6 Z" id="pt-path-1"></path>
        </defs>
        <g id="Icon/Nav/Web/ProjectTemplate" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <mask id="pt-mask-2" fill="white">
                <use xlinkHref="#pt-path-1"></use>
            </mask>
            <use id="Network" fill={fillColor} fillRule="nonzero" xlinkHref="#pt-path-1"></use>
        </g>
    </svg>
  );
};
export default ProjectTypesIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/ProjectTypesIcon/index.js